import request from '../../untils/request';

export function selectDicValueByDicKey(param) {
  return request({
    url: '/systemCustomConfig/selectDicValueByDicKey',
    method: 'get',
    params: { dicKey: param },
  });
}
